














































import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { ContextsState } from '@/store';
import DataSource from 'devextreme/data/data_source';
import {
    Table,
    TableOptions,
    removeItemsFromView,
    getTableCaption,
} from '@/core/components/table';
import { Page } from '@/core/components/controls';
import { DxDataGrid } from 'devextreme-vue/data-grid';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract,
    EventsServiceContract,
    Events
} from '@/core/contracts';
import { lookupField, guid } from '@/core/helpers';
import { Crane, Site, ActivitySchedule } from '@/dto';
import { IContext } from '@/api/dto';
import CranesListTable from './CranesListTable.vue';
import DevExpress from 'devextreme/bundles/dx.all';
import { TargetTypes } from '@/pages/unavailabilityIntervals/types.ts';

@Component({
    components: {
        DxDataGrid,
        CranesListTable,
        TableOptions,
    },
})
export default class CranesListPage extends Page {
    public table: Table | null = null;
    public tableKey: string = 'cranes-control';
    private resourceTypes: any[] | undefined = [];
    private sites: Site[] = [];
    private activityShedules: ActivitySchedule[] = [];

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public setTable(table: Table): void {
        this.table = table;
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get sitesList(): Site[] {
        return this.sites;
    }

    public get dataSource(): DataSource {
        return new DataSource({
            key: 'id' as keyof Crane,
            load: this.load,
            insert: (crane: Crane) => this.insert(crane),
            update: (id: string, data: Crane) => this.update(id, data),
        });
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public get isRowSelected() {
        return this.table && this.table!.getSelectedRowKeys().length === 1;
    }

    public addCrane() {
        this.table!.addRow();
    }

    public editCrane() {
        const selectedKey = this.table!.getSelectedRowKeys()[0];

        if (selectedKey) {
            const selectedIndex = this.table!.getRowIndexByKey(selectedKey);
            this.table!.editRow(selectedIndex);
        }
    }

    public get selectedRow() {
        if (this.table && this.table!.getSelectedRowKeys().length === 1) {
            return this.table!.getSelectedRowKeys()[0];
        }
    }

    private showInactivityIntervals() {
        this._windowsService!.open('unavailability-intervals-list-page', {
            type: TargetTypes.Crane,
            alias: this.selectedRow
        });
    }

    private deleteCrane() {
        const table = this.$refs['table-component'] as CranesListTable;
        table.deleteCrane();
    }

    private async load() {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}/Cranes`;
        const sitesUrl = `/files/contexts/${currentContextId}/Sites`;
        const resourceTypesUrl = `/files/contexts/${currentContextId}/ResourceTypes`;
        const activitySheduleUrl = `/files/contexts/${currentContextId}/ActivitySchedules`;

        const activitySheduleData = await this._fetchService!.get<IContext>(activitySheduleUrl);
        this.activityShedules = activitySheduleData.activitySchedules ? activitySheduleData.activitySchedules : [];
        const sitesData =  await this._fetchService!.get<IContext>(sitesUrl);
        this.sites = sitesData.sites as Site[];
        const resourceTypesData = await this
            ._fetchService!.get<IContext>(`/files/contexts/${currentContextId}/ResourceTypes`);
        this.resourceTypes = resourceTypesData.resourceTypes as any;
        const data = await this._fetchService!.get<IContext>(url);
        return data.cranes ? this.transform(data.cranes) : [];
    }

    private transform(data: any[]) {
        return data.map((item: any) => {
            if (item.isActive === undefined) {
                item.isActive = true;
            }

            if (item.tag) {
                item.tag = (item.tag as string)
                    .split(',')
                    .map(tag => tag.trim());
            }

            return item;
        });
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private async insert(crane: Crane) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        crane.id = guid();
        if (crane.tag && typeof crane.tag !== 'string') {
            crane.tag = crane.tag.join(',');
        }
        if (crane.preferredOperationType === '') {
            crane.preferredOperationType = null;
        }
        const data = {
            Cranes_Partial: [crane],
        };
        return await this._fetchService!.post<Crane>(
            url,
            JSON.stringify(data)
        );
    }

    private async update(id: string, crane: Crane) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        crane.id = id;
        if (crane.tag && typeof crane.tag !== 'string') {
            crane.tag = crane.tag.join(',');
        }
        if (crane.preferredOperationType === '') {
            crane.preferredOperationType = null;
        }
        const data = {
            Cranes_Partial: [crane],
        };
        return await this._fetchService!.post<Crane>(
            url,
            JSON.stringify(data)
        );
    }
}
